;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Layout 		= APP.module('Layout');
	var Collection 	= APP.module('Collection');

	Layout.LeaguesRegenerationRegions = Marionette.LayoutView.extend({
		template: JST.LeaguesRegenerationRegions,
		regions: {
			stepsProgress: "#steps-progress",
			stepHolder: '#step-holder'
		}
	});

}(window, APP, Backbone, Marionette, $, _));